import React from 'react';
import EditButton from '../../../components/ui/EditButton';

export default function BrandingCard({ brand, clubUrlSlug = '', onEdit }) {
  const formatLabel = (key) =>
    key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase());

  const entries = Object.entries(brand || {})
    .filter(([key]) => key !== 'logoUrl');

  const logoUrl = brand?.logoUrl;

  return (
    <div className="team-card">
      <div className="card-header-with-icon">
        <span className="card-title">Branding</span>
        <EditButton section="brand" onEdit={onEdit} />
      </div>
      <div className="card-body">
        {clubUrlSlug && <div className="form-group">
          <strong>Club URL</strong>
          <a href={`/teams/${clubUrlSlug}`} style={{ display: 'block', overflowWrap: 'anywhere' }}>
            {window.location.origin}/teams/{clubUrlSlug}
          </a>
        </div>}
        {logoUrl && (
          <div className="brand-logo-preview">
            <img src={logoUrl} alt="Team logo" onError={(e) => (e.target.style.display = 'none')} />
          </div>
        )}

        {entries.length > 0 ? (
          <ul className="branding-list">
            {entries.map(([key, value]) => (
              <li key={key} className="branding-item">
                <span className="branding-swatch" style={{ backgroundColor: value }} />
                <span className="branding-key">{formatLabel(key)}</span>
                <span className="branding-value" style={{ color: value }}>{value}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-muted">No branding customisations set.</p>
        )}
      </div>
    </div>
  );
}
